import { defineStore } from 'pinia';
import CrmReportsAPI from 'dashboard/api/crmReports';

const DEFAULT_FILTERS = Object.freeze({
  period: 'current_month',
  // Sobre qual data o período recorta: 'created' (quando o lead entrou) ou
  // 'closed' (quando fechou). Vale para todas as abas, como o período.
  dateField: 'created',
  dateFrom: null,
  dateTo: null,
  funnelId: null,
  inboxId: null,
  agentId: null,
  // Campos personalizados da conversa do tipo lista (ex.: { marca: 'Fiat' }).
  // Vazio = sem recorte. Vai pro servidor como conv_attrs[chave]=valor.
  convAttrs: {},
  comparePrevious: false,
});

const filtersToParams = filters => {
  const out = {
    period: filters.period,
    date_field: filters.dateField,
    compare_previous: filters.comparePrevious,
  };
  if (filters.period === 'custom') {
    out.date_from = filters.dateFrom;
    out.date_to = filters.dateTo;
  }
  if (filters.funnelId) out.funnel_id = filters.funnelId;
  if (filters.inboxId) out.inbox_id = filters.inboxId;
  if (filters.agentId) out.agent_id = filters.agentId;
  const convAttrs = Object.fromEntries(
    Object.entries(filters.convAttrs || {}).filter(([, value]) => value)
  );
  if (Object.keys(convAttrs).length) out.conv_attrs = convAttrs;
  return out;
};

export const useCrmReportsStore = defineStore('crmReports', {
  state: () => ({
    filters: { ...DEFAULT_FILTERS, convAttrs: {} },
    responses: { origin: null, platform: null, ad: null },
    loading: { origin: false, platform: false, ad: false },
    errors: { origin: null, platform: null, ad: null },
  }),
  actions: {
    setFilter(key, value) {
      this.filters = { ...this.filters, [key]: value };
      this.invalidateAll();
    },
    setConvAttr(key, value) {
      const convAttrs = { ...this.filters.convAttrs };
      if (value) convAttrs[key] = value;
      else delete convAttrs[key];
      this.setFilter('convAttrs', convAttrs);
    },
    invalidateAll() {
      this.responses = { origin: null, platform: null, ad: null };
    },
    async fetchReport(dimension) {
      this.loading[dimension] = true;
      this.errors[dimension] = null;
      try {
        const params = { ...filtersToParams(this.filters), dimension };
        const { data } = await CrmReportsAPI.getOrigins(params);
        this.responses[dimension] = data;
      } catch (e) {
        this.errors[dimension] =
          e.response?.data?.error || e.message || 'Erro ao carregar relatório';
      } finally {
        this.loading[dimension] = false;
      }
    },
    async exportCsv(dimension) {
      const params = { ...filtersToParams(this.filters), dimension };
      const { data } = await CrmReportsAPI.exportOriginsCsv(params);
      const today = new Date().toISOString().slice(0, 10);
      const filename = `relatorio-${dimension}-${this.filters.period}-${today}.csv`;
      const url = URL.createObjectURL(
        new Blob([data], { type: 'text/csv;charset=utf-8' })
      );
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    },
  },
});
